import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=4ddc6a7e&"
import script from "./AdminEdit.vue?vue&type=script&lang=ts&"
export * from "./AdminEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports